import type { Target } from "@/generated/fastapi";

export function getTargetDisplayLabel(target: Target) {
  if (target.abbr) return target.abbr;

  const parts = [target.position, target.context]
    .map((part) => part?.trim())
    .filter(Boolean);

  return parts.length > 0 ? parts.join(" · ") : target.id;
}

export function getTargetDisplayDescription(target: Target) {
  const content = target.content?.trim();

  if (!content) return undefined;

  return content.length > 140 ? `${content.slice(0, 137)}...` : content;
}
